/* unplugin-vue-components disabled */import { render } from "./uploader.vue?vue&type=template&id=5a946d8f"
import script from "./uploader.vue?vue&type=script&lang=js"
export * from "./uploader.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/uploader/uploader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a946d8f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a946d8f', __exports__)) {
    api.reload('5a946d8f', __exports__)
  }
  
  module.hot.accept("./uploader.vue?vue&type=template&id=5a946d8f", () => {
    api.rerender('5a946d8f', render)
  })

}


export default __exports__